/**
 * Gate for the irreversible "Delete permanently" action: the user must type
 * the item's exact name (case-sensitive; surrounding whitespace ignored).
 * Empty input never matches. This is the single heavy guard in the Archive
 * flow — the only genuinely irreversible step.
 */
export function confirmMatches(typed: string, expected: string): boolean {
  const t = typed.trim();
  return t.length > 0 && t === expected.trim();
}
